import {axios, abortController} from '../../../config/axios-config'

const getSetorAgregado = async () => {
    try {
        let response = null
        response = await axios.post('/pnad/retornaSetoresAgregados', {cancelToken: abortController.token, timeout: 60000})
        return response.data
    } catch (error) {
        console.log(error)
    }
}
export default getSetorAgregado